var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2113 2.13092C22.3834 2.49231 21.5012 2.73185 20.5814 2.84815C21.5276 2.286 22.2498 1.40262 22.5893 0.337846C21.7071 0.861231 20.7331 1.23092 19.695 1.43723C18.8573 0.549693 17.6634 0 16.3609 0C13.834 0 11.7996 2.04092 11.7996 4.54292C11.7996 4.90292 11.8302 5.24908 11.9054 5.57862C8.11072 5.39446 4.75303 3.58477 2.4974 0.828C2.1036 1.50785 1.87262 2.286 1.87262 3.12369C1.87262 4.69662 2.68664 6.09092 3.90004 6.89815C3.16671 6.88431 2.44731 6.67246 1.83783 6.33877C1.83783 6.35262 1.83783 6.37062 1.83783 6.38862C1.83783 8.59569 3.41997 10.4289 5.4947 10.8512C5.12317 10.9523 4.71824 11.0008 4.29801 11.0008C4.00579 11.0008 3.71079 10.9842 3.43388 10.9232C4.02527 12.7218 5.70342 14.0442 7.69884 14.0871C6.14592 15.2958 4.17416 16.0242 2.0396 16.0242C1.66528 16.0242 1.30627 16.0075 0.947266 15.9618C2.96912 17.2592 5.36529 18 7.94931 18C16.3484 18 20.9404 11.0769 20.9404 5.076C20.9404 4.87523 20.9334 4.68138 20.9237 4.48892C21.8296 3.84923 22.5907 3.05031 23.2113 2.13092Z",
    fill: "#000B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0e5ec74be216d188d9350ff39facc088.svg";
export { ForwardRef as ReactComponent };